"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const flow_connect_1 = require("flow-connect");
const function_plotter_js_1 = require("./function-plotter.js");
const line_chart_mini_js_1 = require("./line-chart-mini.js");
flow_connect_1.FlowConnect.register({ type: "node", name: "visual/function-plotter" }, function_plotter_js_1.FunctionPlotter);
flow_connect_1.FlowConnect.register({ type: "node", name: "visual/line-chart-mini" }, line_chart_mini_js_1.LineChartMini);
